import axios from '@/plugins/axios'

export function getDepositOrders(params = {}) {
  return axios.get('deposit', {
    params,
  })
}
export function getrefundLogs(params = {}) {
  return axios.get('deposit/refundLogIndex', {
    params,
  })
}

export function getDepositStatistics(params = {}) {
  return axios.get('deposit/statistics', {
    params,
  })
}

export function getDepositdepositTotal(params = {}) {
  return axios.get('deposit/depositTotal', {
    params,
  })
}
